<!--
 * @Author: your name
 * @Date: 2022-03-02 14:23:57
 * @LastEditTime: 2022-03-16 17:49:08
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /demander-manage/src/views/orderManagement/components/order/order.vue
-->
<template>
  <div class="orderLists">
    <div ref="orderLists" class="OrderItem" style="position:relative;">
      <div v-if="showCheckCopy && type == 1" class="checkCopy" @click="allCheckChange" />
      <el-table
        v-if="!tableData.length"
        class="firstTable"
        :data="showData"
        :span-method="objectSpanMethod"
        border
        style="width: 100%; background: #f5f5f5;"
        :header-cell-style="{background:'#fff',color:'#666666',height:'54px',fontWeight:'400',border:'0'}"
      >
        <el-table-column :resizable="false" width="-1" />
        <el-table-column prop="goodsName" width="650" label="商品" align="left" :resizable="false">
          <template slot="header">
            <div style="padding-left:10px;">
              <el-checkbox v-if="rols('审批') &&type == 3" v-model="allChecked" :disabled="allDisabled" :indeterminate="isIndeterminate" @change="allCheckChange" />
              <span style="margin-left:105px;">商品</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="单价/数量" align="center" :resizable="false" />
        <el-table-column prop="amount1" label="收货人" align="center" :resizable="false" />
        <el-table-column prop="amount2" label="订单金额" align="center" :resizable="false" />
        <el-table-column prop="amount3" label="审批状态" align="center" :resizable="false" />
        <el-table-column prop="amount3" label="订单操作" align="center" :resizable="false" />
      </el-table>
      <div v-for="(item,index) in tableData" :key="index" class="allTable">
        <el-table
          :class="index ? 'secondTable' : ''"
          :data="item.ForderDetailList"
          :span-method="objectSpanMethod"
          border
          style="width: 100%; background: #f5f5f5;"
          :header-cell-style="{background:'#fff',color:'#666666',height:'54px',fontWeight:'400',border:'0'}"
          :cell-style="{fontSize:'14px',color:'#333'}"
          :cell-class-name="cellName"
          :row-class-name="rowName"
        >
          <el-table-column width="-1">
            <template slot-scope="scope">
              <div v-if="scope.row.row === true" class="order-title">
                <div class="title-left">
                  <div class="row-box">
                    <el-checkbox v-if="(rols('审批') && type == 1)||type==3" :key="tableKey" v-model="item.isChecked" :disabled="item.disabled&&type!=3" style="margin-right:14px;" @change="itemChange" />
                    <div style="width:12%;"><span style="width:100%;" class="over_text">{{ item.FBillDate }}</span></div>
                    <div><span>订单号：</span><span class="over_text">{{ item.FOrderNo }}</span></div>
                    <div><span>下单人：</span><span class="over_text">{{ item.FUserName }}</span></div>
                    <div>订单备注：
                      <span><el-popover
                        v-if="item.FRemark"
                        placement="top-start"
                        width="200"
                        trigger="click"
                        :content="item.FRemark"
                      >
                        <i
                          slot="reference"
                          style="color:#F5783C;font-size: 14px;"
                          class="el-icon-warning-outline"
                        />
                      </el-popover></span>
                    </div>
                    <div><span>下单部门：</span><span class="over_text">{{ item.FDepartName }}</span></div>
                    <div v-if="item.forderStatus == 2 || item.forderStatus == 5" class="dltIcon" @click="operateOrder(item,1)">
                      <i class="el-icon-delete" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="650" label="商品" align="left" :resizable="false">
            <template slot="header">
              <div style="padding-left:10px;">
                <el-checkbox v-if="(rols('审批') && type == 1) || type==3" :key="tableKey" v-model="allChecked" :disabled="allDisabled&&type!=3" :indeterminate="isIndeterminate" @change="allCheckChange" />
                <span style="margin-left:105px;">商品</span>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="goods">
                <div class="goodsImg">
                  <el-image
                    style="width: 107px; height: 107px"
                    :src="scope.row.FStockImagePath"
                    :preview-src-list="[scope.row.FStockImagePath]"
                  >
                    <div slot="error" class="image-slot">
                      <!-- <i class="el-icon-picture-outline" /> -->
                      <img src="../../../assets/images/stockImg.jpg" alt="">
                    </div>
                  </el-image>
                </div>
                <div class="goodsInfo">
                  <div class="goodsName"><span
                    @click="toDetail(scope.row,item)"
                  >{{ scope.row.FStockName }}</span></div>
                  <div class="goodsExplain">
                    <div>
                      订货编码：
                      <span v-if="scope.row.FShortCode" class="code" @click="copyCode(scope.row.FShortCode)">{{ scope.row.FShortCode | filterCode }}<i class="el-icon-document-copy" /></span>
                    </div>
                    <div>
                      需方编码：
                      <span v-if="scope.row.FDemandStcokCode" class="code" @click="copyCode(scope.row.FDemandStcokCode)">{{ scope.row.FDemandStcokCode | filterCode }}<i class="el-icon-document-copy" /></span>
                    </div>
                    <div>
                      明细备注：
                      <el-popover
                        v-if="scope.row.FDetailRemark"
                        placement="top-start"
                        width="200"
                        trigger="click"
                        :content="scope.row.FDetailRemark"
                      >
                        <i
                          slot="reference"
                          style="color:#F5783C; "
                          class="el-icon-warning-outline"
                        />
                      </el-popover>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价/数量" align="center" :resizable="false" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="overText">
                <template v-if="FPriceShow">
                  ￥{{ scope.row.FTotalPrice }}
                </template>
                <div v-else id="noShowPrice" style="margin-right: 5px;">
                  <span style="margin:0;">￥</span>价格不可见
                </div>
                <span v-if="FPriceShow" style="margin:0 5px;">
                  X
                </span>
                <span>
                  {{ scope.row.FQuanty }}
                  <span v-if="scope.row.FMeasurement">{{ scope.row.FMeasurement }}</span>
                </span>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="" label="收货人" align="center" :resizable="false">
            <template slot-scope="scope">
              <span style="color:#333;">
                {{ item.FReceiver }}
              </span>
              <el-popover placement="bottom-start" width="465" trigger="click">
                <div class="deliveryInfo">
                  <p><span style="margin-right:10px;">{{ item.FReceiver }}</span>{{ item.FReceiverPhoneNo }}</p>
                  <p>{{ item.FReceiverAddress }}</p>
                </div>
                <i slot="reference" style="color:#F5783C;font-size: 14px; " class="el-icon-warning-outline" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" align="center" :resizable="false">
            <template slot-scope="scope">
              <div v-if="scope.$index == 1 && FPriceShow" v-html="filterMoney(item.FTotalAmount)" />
              <span v-else id="noShowPrice">
                <span style="margin:0;">￥</span>价格不可见
              </span>
            </template>
          </el-table-column>
          <el-table-column label="审批状态" align="center" :resizable="false">
            <template slot-scope="scope">
              <template>
                <span v-if="item.FApprovalStatus === 0">待审批</span>
                <span
                  v-if="item.FApprovalStatus === 1"
                >审批中</span>
                <span
                  v-if="item.FApprovalStatus === 2"
                >已拒绝</span>
                <span v-if="item.FApprovalStatus === 3">已通过</span>
                <span v-if="item.FApprovalStatus === 4">已取消</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column align="center" label="订单操作" :resizable="false">
            <template slot-scope="scope">
              <div v-if="scope.$index == 1" class="btn">
                <div v-if="rols('查看详情')" class="detail-btn" @click="toApproval(1,item)">查看详情</div>
                <div v-if="item.FNeedAdudit&&rols('审批')" class="detail-btn" @click="toApproval(0,item)">审批</div>
                <div v-if="(item.FApprovalStatus === 0 || item.FApprovalStatus === 1) && type == 1" class="detail-btn" @click="toEditNum(item)">修改数量</div>
                <div v-if="rols('再来一单') && scope.row.approvalQuery" class="detail-btn" @click="$parent.allOperation(0,item)">再来一单</div>
                <div v-if="(item.FApprovalStatus === 0 || item.FApprovalStatus === 1) && type == 3" class="detail-btn" @click="tipVisible = true,selectOrder = item">取消审批</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="fixed" :style="fixedWidthEl" @scroll="modelFixed">
      <div :style="'width:'+fixedWidth+'px'" />
    </div>

    <tipsDia
      :tip-visible="tipVisible"
      :tip-type="3"
      @closeTips="tipVisible = false"
      @cfmTips="cfmTips"
    />

    <editNum
      :edit-visible="editVisible"
      :edit-list="editList"
      :f-info-i-d="fInfoID"
      @closeEdit="closeEdit"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import tipsDia from '../orderManagement/components/order/tips.vue'
import editNum from './editNum.vue'
export default {
  components: {
    tipsDia,
    editNum
  },
  filters: {
    filterCode(val) {
      if (val) return val.slice(0, 9)
    }
  },
  // 接受父组件的值
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    type: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      fInfoID: null,
      editList: [],
      editVisible: false,
      selectOrder: null,
      tipVisible: false,
      allDisabled: false,
      isIndeterminate: false,
      allChecked: false,
      afterList: [],
      operateItem: null,
      tipType: 0,
      changeRow: null,
      changeCode: null,
      selectCode: '',
      tipTitle: 1,
      tipdia: false,
      details: false,
      showData: [],
      selectStatus: [
        '待付款',
        '待接单',
        '已取消',
        '待发货',
        '待收货',
        '已完成'
      ],
      FPriceShow: 0,
      fixedWidth: 0,
      fixedWidthEl: 0,
      tableKey: 0,
      showCheckCopy: false
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('订单审批')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  watch: {
    tableData: {
      deep: true,
      handler(newValue, oldValue) {
        if (!newValue.length) {
          this.allDisabled = true
        } else {
          const i = newValue.findIndex(t => !t.disabled)
          this.allDisabled = i == -1
        }
        this.$forceUpdate()
        this.$nextTick(this.resizeWidth)
      }
    },
    orderStatus: {
      handler(newValue, oldValue) {
        var that = this
        that.orderStatus = newValue
        this.tableData.forEach(item => {
          this.$set(item, 'status', newValue)
        })
      }
    }
  },
  created() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    this.listenerFunction()
    // console.log(this.$route)
  },
  mounted() {
    window.onresize = this.resizeWidth
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.listenerFunction)
  },
  methods: {
    closeEdit(val) {
      this.editVisible = false
      if (val) this.$parent.onSearch()
    },
    allOperation(val, item) {
      this.selectItem = item
      this.tipsType = val
      this.tipsVisible = true
    },
    toEditNum(t) {
      this.fInfoID = t.FInfoID
      const arr = []
      t.ForderDetailList.map((t, i) => {
        if (i !== 0) {
          this.$set(t, 'editNum', t.FQuanty)
          this.$set(t, 'isEdit', false)
          arr.push(t)
        }
      })
      //   t.ForderDetailList.slice(1, t.ForderDetailList.length)
      this.editList = arr
      this.editVisible = true
    },
    cfmTips() {
      request({
        url: `/mall/mallmanage/billapprovalinfo/cancelApproval?FInfoID=${this.selectOrder.FInfoID}`,
        method: 'post'
      })
        .then(res => {
          if (res.result) {
            this.tipVisible = false
            this.$parent.onSearch()
            this.$message.success(res.msg)
            this.$parent.$parent.$parent.$refs.rightNav.getComput()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {

        })
    },
    allCheckChange(val) {
      console.log(val)
      
      if(this.type==3){
        this.$parent.tableData.forEach(t => {
        t.isChecked =val
      })
      this.isIndeterminate=false;
        return
      }
      let b = null
      b = this.$parent.tableData.findIndex(t => t.isChecked && !t.disabled) == -1
      if (this.isIndeterminate) b = true
      this.$parent.tableData.forEach(t => {
        if (!t.disabled) t.isChecked = b
      })
      this.tableKey++
      this.itemChange()
    },
    itemChange() {
      let n = 0
      this.tableData.forEach(t => {
        if (t.isChecked) n++
      })
      if (n) {
        const b = n == this.tableData.length
        this.allChecked = b
        this.isIndeterminate = !b
      } else {
        this.allChecked = false
        this.isIndeterminate = false
      }
      if (document.getElementById('el-table__body_efefef')) {
        const check = document.getElementById('el-table__body_efefef').getElementsByClassName('el-checkbox__input')[0]
        let c = ''
        let l = ''
        if (this.allChecked) (c = 'is-checked', l = 'is-indeterminate')
        if (this.isIndeterminate) (c = 'is-indeterminate', l = 'is-checked')
        if (c && l) {
          if (!check.classList.contains(c)) check.classList.add(c)
          if (check.classList.contains(l)) check.classList.remove(l)
        } else {
          if (check.classList.contains('is-checked')) check.classList.remove('is-checked')
          if (check.classList.contains('is-indeterminate')) check.classList.remove('is-indeterminate')
        }
      }
    },
    toApproval(n, t) {
      this.$parent.toApproval(n, t)
    },
    modelFixed(e) {
      const left = e.target.scrollLeft
      if (this.$refs.orderLists) this.$refs.orderLists.scrollLeft = left
      // console.log(e)
      if (document.getElementById('el-table__body_efefef'))document.getElementById('el-table__body_efefef').scrollLeft = left
    },
    resizeWidth() {
      this.$nextTick(() => {
        const el = document.querySelector('.OrderItem .el-table__body-wrapper')
        if (el) {
          // console.log(el.offsetWidth)
          this.fixedWidth = el.offsetWidth
        }
        // console.dir(this.$refs.orderLists)
        this.fixedWidthEl = {
          width: this.$refs.orderLists.offsetWidth + 'px',
          left: 235 + 'px'
        }
        const els = document.getElementById('el-table__body_efefef')
        if (els) {
          if (els.style) {
            els.style.width = this.$refs.orderLists.offsetWidth + 'px'
          } else {
            els.style.width = 'auto'
          }
        }
        this.fixedPosition()
      })
    },
    fixedPosition() {
      const html = document.firstElementChild
      const h = html.scrollTop + html.clientHeight
      let obj = {
        width: this.$refs.orderLists.offsetWidth + 'px',
        left: 235 + 'px'

      }
      if (html.scrollHeight - h < 100) {
        obj = {
          position: 'initial',
          'margin-top': '-11px'
        }
      }
      this.fixedWidthEl = obj
    },
    cellName({ row, column, rowIndex, columnIndex }) {
      if (column.label != '单价/数量') {
        return 'noBorder'
      }
    },
    rowName({ row, rowIndex }) {
      if (!rowIndex) return 'noHover'
    },
    copyCode(val) {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.setAttribute('create', 1)
      input.select()
      document.execCommand('Copy')
      var list = document.getElementsByTagName('input')
      var inputList = Array.prototype.slice.call(list)
      inputList.forEach((item) => {
        if (item.getAttribute('create'))document.body.removeChild(item)
      })
    },
    filterMoney(val) {
      const m = (val || 0).toFixed(2)
      const str = `<span style='font-size:12px;font-weight:bold;color:#EC212D;'>￥<span style='font-size:16px;'>${m.split('.')[0]}</span>.${m.split('.')[1]}</span>`
      return str
    },
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true)
    },
    // 监听滚动条,固定表头
    handleScroll() {
      if (this.$route.path === '/approvalQuery/approvalQuery') {
        const yOffSet = window.pageYOffset
        const headerOrg = this.$refs.orderLists.getElementsByClassName('el-table__header-wrapper')
        const header = this.$refs.orderLists.getElementsByClassName('el-table__header-wrapper')[0].cloneNode()
        headerOrg[0].childNodes.forEach(item => header.append(item.cloneNode(true)))

        this.fixedPosition()
        // const table = this.$refs.orderLists.getElementsByClassName('el-table__body-wrapper')
        if (yOffSet > 333) {
          if (document.getElementById('el-table__body_efefef')) return
          document.getElementById('el-table__body_efefef') && document.getElementById('el-table__body_efefef').remove()
          header.setAttribute('id', 'el-table__body_efefef')
          header.setAttribute('style', 'position:fixed;top:2px;z-index:999;height:55px;overflow:hidden;')
          headerOrg[0].parentNode.append(header)
          this.resizeWidth()
          this.showCheckCopy = true
        }
        if (yOffSet < 330) {
          document.getElementById('el-table__body_efefef') && document.getElementById('el-table__body_efefef').remove()
          header.removeAttribute('style')
          this.showCheckCopy = false
        }
      }
    },
    toDetail(row, item) {
    //   return console.log(row, item)
      if (!row.IsDirectoryPool) return
      if (row.FShelfed === 0) {
        return this.$message.error('该商品未上架')
      }
      if (row.FShelfed === 2) {
        return this.$message.error('该商品已下架')
      }
      if (!row.isChange) {
        this.$router.push({
          path: '/store/details',
          query: {
            mallstorestockFId: row.fmallstoreStockId,
            shopid: row.FMallStoreID
          }
        })
      }
    },
    returnPrice(item) {
      let n = 0
      item.fdetails.forEach((t, i) => {
        if (i !== 0) {
          n += Number(t.FReturnAmount)
        }
      })
      return `￥${n}`
    },
    objectSpanMethod({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (columnIndex > 2) {
        return {
          rowspan: 99,
          colspan: 1
        }
      }
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return [1, 9]
        } else {
          return [0, 0]
        }
      }
    }
  }
}
</script>

<style lang="scss">
.fixed{
  position: fixed;
  width: 100%;
  height: 20px;
    background: transparent;
  left:0;
  overflow-x: overlay;
  z-index:9;
  bottom: 0;
  &>div{
    width: 2000px;
  }
}
    .deliveryInfo {
        p {
            // height: 30px;
            line-height: 30px;
            // margin-bottom: 12px;
            color: #333333;
            font-weight: bold;
        }

        .address {
            font-weight: 400;
            margin-bottom: 0;
        }
    }

    .firstTable {
        .el-table__body-wrapper {
            display: none;
        }
    }

    .secondTable {
        .el-table__header-wrapper {
            display: none;
        }
    }

    .orderLists {
        width: 100%;

        // transform: scale(1);
        .el-table__header-wrapper {
            margin-bottom: 10px;
        }

        .firstTable .el-table__header-wrapper {
            margin-bottom: 0;
        }

        .allTable {
            .el-checkbox__input,.el-checkbox__inner {
                min-width: 14px !important;
            }
            .noBorder {
                border-right: 0;
            }
            .noHover .el-table__cell {
                padding: 0;
                &:hover {
                    background-color: #fff;
                }
            }
            .approvalSttatus {
                    // display: inline-block;
                    // width: 78px;
                    // height: 36px;
                    // line-height: 36px;
                    // text-align: center;
                    // border-radius: 4px;
                    // background-color: #FFF6EB;
                    // color: #FFAA47;
                    // font-size: 18px;
            }
        }

        #noShowPrice {
            // display: inline-block;
            text-align: center;
            font-size: 14px;
            color: #ec2631;
            font-weight: 400;
            span {
                font-size: 12px;
            }
        }
    }

    .service-btn {
        width: 70px;
        height: 28px;
        line-height: 28px;
        background: #FFFFFF;
        border: 1px solid #CDCDCD;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        cursor: pointer
    }

    .evaluate {
        cursor: pointer;
        width: 55px;
        height: 28px;
        line-height: 28px;
        background: #EC212D;
        color: #fff;
        text-align: center;
        border-radius: 5%;
    }

    .detail-btn {
        width: 68px;
        height: 26px;
        line-height: 26px;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        &:hover {
            color: #EC212D;
        }
    }

    .no-detail-btn {
        border: 1px solid #999;
        color: #333;
    }

    .OrderItem {
        width: 100%;
        margin: 10px 0px;
        background: #f5f5f5;
        overflow-x: hidden;
        .checkCopy {
            cursor: pointer;
            caret-color: transparent;
            width: 14px;
            height: 14px;
            z-index: 99999;
            position: fixed;
            top: 21px;
            margin-left: 21px;
            background-color: transparent;
            border-radius: 2px;
            border: 1px solid transparent;
            &:hover {
                border-color: #EC212D;
            }
        }
        .allTable{
          overflow: initial;
          .el-table{
            overflow: initial;
            width: calc(100% - 2px) !important;
            tbody tr:hover > td {
                background-color: transparent
            }
            .el-table__body{
              overflow: hidden;
            }
            .el-table__header-wrapper{
              width: fit-content;
            }
            .el-table__body-wrapper{
              width: fit-content;
              overflow: initial;
            }
          }
        }
        .el-table__body-wrapper{
          margin-bottom: 10px;
        }
        .order-title {
            padding: 0 10px;
            width: 100%;
            height: 40px;
            line-height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            box-sizing: border-box;

            .title-left {
                width: 100%;
                align-items: center;

                .row-box {
                    display: flex;
                    position: relative;
                    margin-right: 0;

                    >div {
                        display: flex;
                        width: 20%;
                        .over_text {
                            width: calc(100% - 60px);
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }

                    .dltIcon {
                        cursor: pointer;
                        position: absolute;
                        font-size:17px;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 24px;
                        height: 24px;
                        margin-right: 0;
                        border-radius: 2px;
                        line-height: 24px;
                        text-align: center;
                        color: red;
                        &:hover {
                            background-color: #F3F3F3;
                        }
                    }

                    div {
                        line-height: 40px;
                        span {
                            display: inline-block;
                            width: 60px;
                            min-width: 60px;
                        }
                    }

                }
            }
        }
        .overText {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .price,
        .number,
        .goodsOperate,
        .money,
        .status,
        .orderOperate,
        .operate-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
        }

        .remark {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
        }

        .service {
            width: 62px;
            height: 22px;
            background: #FFFFFF;
            border: 1px solid #CDCDCD;
            border-radius: 2px;
        }

        .btn {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

        }

        .goods {
            min-width: 550px;
            display: flex;
            box-sizing: border-box;
            padding: 10px 20px 10px 10px;

            .goodsImg {
                width: 107px;
                height: 106px;
                margin-right: 13px;

                .image-slot {
                    width: 107px;
                    height: 107px;
                }

                img {
                    width: 107px;
                    height: 107px;
                }

                .el-image {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #f5f7fa;
                }
            }

            .goodsInfo {
                color: rgb(103, 107, 124);
                flex: 1;

                .goodsName {
                    text-align: left;
                    height: 47px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;

                    span {
                        cursor: pointer;
                    }

                    span:hover {
                        text-decoration: underline;
                        color: #EC212D;
                    }
                }

                .goodsExplain {
                    width: 100%;
                    height: 20px;
                    text-align: left;
                    font-size: 12px;
                    font-weight: 400;
                    color: #777;
                    box-sizing: border-box;
                    padding: 0 30px 0 0px;

                    >div {
                        height: 22px;
                    }

                    .el-icon-edit {
                        font-size: 18px;
                        cursor: pointer;
                    }

                    .code {
                        cursor: pointer;
                    }

                }
            }
        }

    }

    #el-table__body_efefef{
      .is-leaf{
        background-color: #efefef !important;
      }
    }
</style>>
